import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';

import { CookieService } from 'ngx-cookie-service';
import { httpInterceptorProviders } from './http-interceptors';

import { MsComponent } from './components/ms/ms.component';

import { CoreConfigModule } from './core.config.module';
import { NavComponent } from './components/nav/nav.component';
import { NavPanelComponent } from './components/nav/nav-panel/nav-panel.component';
import { NavHeaderComponent } from './components/nav/nav-header/nav-header.component';

@NgModule({
    declarations: [MsComponent, NavComponent, NavPanelComponent, NavHeaderComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        CoreConfigModule,
        UIRouterModule,
        // Angular Material modules. Only export what will be used by rest of the app
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatMenuModule,
        MatIconModule
    ],
    exports: [MsComponent, NavComponent, NavPanelComponent, NavHeaderComponent],
    providers: [CookieService, httpInterceptorProviders]
})
export class CoreModule {}
